/**
 * Employment Event Validation States
 */
export const EVENT_VALIDATION_STATES = {
  PENDING: 'Pending',
  VALID: 'Valid',
  CANCELLED: 'Cancelled',
  INVALID: 'Invalid',
  SKIPPED: 'Skipped'
};

export const getValidationStateColor = (state) => {
  switch (state) {
    case EVENT_VALIDATION_STATES.VALID:
      return '#10b981';
    case EVENT_VALIDATION_STATES.PENDING:
      return '#f59e0b';
    case EVENT_VALIDATION_STATES.CANCELLED:
      return '#64748b';
    case EVENT_VALIDATION_STATES.INVALID:
      return '#ef4444';
    case EVENT_VALIDATION_STATES.SKIPPED:
      return '#9333ea';
    default:
      return '#64748b';
  }
};

export const getValidationStateTextColor = (state) => {
  return '#ffffff';
};
